import { makeAutoObservable } from 'mobx';
import {calendarDate} from 'shared/tools';

class PositionViewModel {
  position;

  constructor(position) {
    makeAutoObservable(this);

    this.position = position;
  }

  get createdDate() {
    return calendarDate(this.position.createdAt);
  }

  get directoryUrl() {
    return this.position.isDraft ? `/positions/${this.position.id}` : `/positions/${this.position.id}/funnel/`;
  }
}

export default PositionViewModel;
